import { inject, injectable } from 'inversify'
import Debug from 'debug';
import * as Api from '@xlearn/common';
import { PlayerModule } from '@/app/api';
import { HunspellService, HunspellServiceSymbol } from './hunspell-service'
import { replaceBasePathInContent } from '../shared/utils/base-path';

const debug = Debug('hunspell-player-module')

@injectable()
export class HunspellPlayerModule implements PlayerModule {
  readonly name = 'hunspell'
  
  constructor(
    @inject(HunspellServiceSymbol)
    private hunspellService: HunspellService) {}

  start(instance: Api.SerializedAspectInstance): void {

    debug('start', instance)

    const dictionaryUris = this.dictionaryUris(instance)

    this.hunspellService.initialize(dictionaryUris)
    this.hunspellService.start()
  }

  reset(instance: Api.SerializedAspectInstance): void {
    debug('reset', instance)

    const dictionaryUris = this.dictionaryUris(instance)
    this.hunspellService.initialize(dictionaryUris)
  }

  private dictionaryUris(instance: Api.SerializedAspectInstance) {
    const basePath = ''
    const mapped = instance.details.dictionaries.map(x => ({
      language: x.language,
      files: {
        dic: replaceBasePathInContent(basePath)(x.files.dic),
        aff: replaceBasePathInContent(basePath)(x.files.aff)
      }
    }))

    return mapped
  }

  async stop() {
    debug('stop')

    await this.hunspellService.stop()
  }
}
